export default __webpack_public_path__ + "static/media/sure-thing.2c3ce9a6.gif";